module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page', [_c('div', {
    class: {
      'c-show': true, 'low-position': _vm.isEnd
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('show-cover', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEnd),
      expression: "!isEnd"
    }],
    attrs: {
      "show-tips": _vm.showTips,
      "show-coord": _vm.showCoord,
      "coord-index": _vm.coordIndex
    }
  })], 1), _vm._v(" "), (_vm.isEnd) ? _c('show-end-cover', {
    on: {
      "back": _vm.handleBack
    }
  }) : _vm._e(), _vm._v(" "), _c('show-earth', {
    ref: "earth"
  }), _vm._v(" "), _c('show-clouds', {
    ref: "cloudSprite"
  }), _vm._v(" "), _c('show-video-sprite', {
    ref: "videoSprite"
  }), _vm._v(" "), _c('show-audio-sprite', {
    ref: "audioSprite",
    on: {
      "spriteend": _vm.handleAudioSpriteEnd
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('show-actions', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEnd),
      expression: "!isEnd"
    }],
    attrs: {
      "show-press-button": !_vm.showTips,
      "show-xplan-button": _vm.showXplanButton && _vm.revealed
    },
    on: {
      "hold": _vm.handleHold,
      "release": _vm.handleRelease,
      "knowmore": _vm.handleKnowMore
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-58e16c65"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/Show.vue
// module id = 204
// module chunks = 1